import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as dayjs from 'dayjs';
import { GlobalConstants } from 'src/app/constant/constant';
import { TimeRecordService } from 'src/app/services/timeRecord.service';
import { TimeFormControlParams, TimeFormDataValues } from '../time.component';
import { TimeRecord } from 'src/app/entities/timeRecord';
import { DateTimeHelper } from 'src/app/utils/date-time-helper';

@Component({
  selector: 'app-edit-open-time',
  templateUrl: './edit-open-time.component.html',
  styleUrls: ['./edit-open-time.component.scss'],
})
export class EditOpenTimeComponent implements OnInit {
  @Input() interval: number = GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES;
  get INTERVAL() { return this.interval; }

  @Input() userId: number;
  @Input() timeRecordToEdit: TimeRecord;
  @Output() formValuesChanged = new EventEmitter<TimeFormDataValues>();
  timeFormControlParams: TimeFormControlParams;

  constructor(
    private timeRecordService: TimeRecordService
  ) {}

  ngOnInit() {
    this.setFormParams();
  }

  onFormValuesChanged(formValues: TimeFormDataValues) {
    this.formValuesChanged.emit(formValues);
  }

  onIntervalChanged(interval: number) {
    this.interval = interval;
    const now = DateTimeHelper.getLocalNow();
    const nowRounded = DateTimeHelper.roundDateTime(dayjs(now), this.INTERVAL).tz(dayjs.tz.guess());
    const lastAllowedClockIn = this.timeRecordService.getLastAllowedClockInForDay(this.timeRecordToEdit.Date, this.INTERVAL).tz(this.timeRecordToEdit.ClockInTimeZoneId);
    this.timeFormControlParams = {
      ...this.timeFormControlParams,
      startTime: {
        ...this.timeFormControlParams.startTime,
        minValue: this.timeFormControlParams.startTime.minValue,
        maxValue: dayjs.min([nowRounded, lastAllowedClockIn]).format('HH:mm'),
      },
    };
  }

  setFormParams() {
    const now = DateTimeHelper.getLocalNow();
    const nowRounded = DateTimeHelper.roundDateTime(dayjs(now), this.INTERVAL).tz(dayjs.tz.guess());;
    const timeRecordDate = this.timeRecordToEdit.Date;
    const lastAllowedClockIn = this.timeRecordService.getLastAllowedClockInForDay(timeRecordDate, this.INTERVAL).tz(this.timeRecordToEdit.ClockInTimeZoneId);;
    const startOfDay = DateTimeHelper.getStartOfDay(timeRecordDate);

    this.timeFormControlParams = {
      ...this.timeFormControlParams,
      timeRecordToEditRecordId: this.timeRecordToEdit.RecordId,
      date: {
        initialValue: DateTimeHelper.formatDateTime(timeRecordDate),
        isDisabled: true,
      },
      startTime: {
        initialValue: DateTimeHelper.formatDateTime(this.timeRecordToEdit.ClockIn),
        minValue: startOfDay.format('HH:mm'),
        maxValue: dayjs.min([nowRounded, lastAllowedClockIn]).format('HH:mm'),
      },
      endTime: {
        isHidden: true,
      },
      showClockOutButton: true,
    };
  }
}
